module.exports = require("os");;